// Palet warna avatar (kontras cukup dengan teks putih). Dipilih deterministik dari seed
// supaya user yang sama selalu mendapat warna yang sama di semua tempat.
const AVATAR_COLORS = [
    '#2f6fdb', // blue
    '#0e8f7e', // teal
    '#8a4fd6', // purple
    '#c2410c', // orange
    '#be185d', // pink
    '#4d7c0f', // green
    '#0e7490', // cyan
    '#b45309', // amber
    '#4f46e5', // indigo
    '#b91c1c', // red
];

export const getAvatarColor = (seed?: string | null): string => {
    if (!seed) return '#6c757d';

    // Hash string sederhana (djb2) -> index palet.
    let hash = 5381;
    for (let i = 0; i < seed.length; i++) {
        hash = ((hash << 5) + hash + seed.charCodeAt(i)) | 0;
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
